import { useQuery } from "@tanstack/react-query";

import { ApiError } from "src/types/interfaces/api-error";
import { Site } from "src/types/responses/site";
import { organizationDetailsApi } from "../../../organization/api/lib/organization-details";
import { organizationSitesKeys } from "../../api/query-keys/organization-sites";

export const useSites = (onSuccess?: (data: Site[]) => void, enabled?: boolean) => {
  return useQuery<Site[], ApiError>({
    queryKey: organizationSitesKeys.lists(),
    queryFn: () => organizationDetailsApi.fetchOrganizationSites(),
    onSuccess: data => {
      onSuccess?.(data);
    },
    enabled,
  });
};
